import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { getOrgTermsContent } from '../../../../content/utils.js';
import PageHeader from '../../PageHeader.js';
import BreadCrumbs from '../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../icons/ProjectBreadcrumbIcon.jsx';
import {
  InitiativeFilesLink,
  ProjectFilesLink,
  ProjectsLink,
} from '../../../links/index.jsx';

const FilesFormHeader = ({ editing, initiativeId }) => {
  const [searchParams] = useSearchParams();
  const params = useParams();
  const projectId = searchParams.get('projectId') || params.projectId;
  const hasInitiativeId = searchParams.has('initiativeId') || initiativeId;

  return (
    <PageHeader flex>
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>
        {!editing && hasInitiativeId ? (
          <InitiativeFilesLink
            initiative={{ id: initiativeId, type: 'communication' }}
          >
            Linked Files
          </InitiativeFilesLink>
        ) : null}
        {!editing && !hasInitiativeId ? (
          <ProjectFilesLink projectId={projectId}>
            Linked Files
          </ProjectFilesLink>
        ) : null}
        {editing ? <span>Edit Linked File</span> : <span>Add Linked File</span>}
      </BreadCrumbs>
    </PageHeader>
  );
};

export default FilesFormHeader;
